import React from 'react';
import { PropTypes } from 'prop-types';
import CircleDangerIcon from '@icons/CircleDangerIcon/index';

const FormError = ({ text }) => (
    <div className="text-center py-4">
        <CircleDangerIcon />
        <h3 style={{ fontSize: '2rem', marginBottom: '1.5rem', marginTop: '.7rem' }}>Something went wrong.</h3>
        {text && <p style={{ fontSize: '1.125rem' }}>{text}</p>}
    </div>
);

FormError.propTypes = {
    text: PropTypes.string,
};

export default FormError;
